// extracted by mini-css-extract-plugin
export default {"error":"_5D17f8bn","intro":"_5DpczGyc","download-button__wrapper":"_5DEIb5mU"};